import React from 'react';
import StepIndicator from './StepIndicator';
import { useTranslation } from 'react-i18next';

function OtherScreen({ onBack, onClose, feedbackText, onChangeText, onConfirm, isSubmitting }) {
  const { t } = useTranslation();
  const canConfirm = feedbackText.trim().length > 0;

  return (
    <>
      <StepIndicator step={2} onBack={onBack} showBack onClose={onClose} />

      <div className="t-mb-4">
        <h2 className="t-text-[26px] t-font-serif t-text-slate-900 t-leading-tight t-mb-2">
          {t('CancelFlow_Other_Title_Line1')}
          <br />
          <span>
            {t('CancelFlow_Other_Title_Line2').split(' ').slice(0, -1).join(' ')}{' '}
            <em className="t-text-secondary">
              {t('CancelFlow_Other_Title_Line2').split(' ').slice(-1).join(' ')}
            </em>
          </span>
        </h2>
        <p className="t-text-sm t-text-slate-600 t-m-0">{t('CancelFlow_Other_Subtitle')}</p>
      </div>

      <textarea
        className="t-w-full t-h-28 t-rounded-xl t-border-2 t-border-teal-mid t-px-3 t-py-2 t-text-sm t-text-slate-800 focus:t-outline-none focus:t-border-secondary t-mb-3"
        placeholder={t('CancelFlow_Other_Placeholder')}
        value={feedbackText}
        onChange={(e) => onChangeText(e.target.value)}
      />

      <div className="t-flex t-items-center t-gap-2 t-bg-teal-bg t-border-l-4 t-border-secondary t-rounded-lg t-px-3 t-py-2 t-text-[12px] t-text-slate-700 t-mb-4">
        <span className="t-text-secondary">🛡</span>
        <span>{t('CancelFlow_Other_Info')}</span>
      </div>

      <button
        type="button"
        onClick={onConfirm}
        disabled={!canConfirm || isSubmitting}
        className="t-w-full t-inline-flex t-items-center t-justify-center t-rounded-xl t-px-4 t-py-3 t-bg-secondary t-text-white t-font-semibold t-text-sm t-gap-2 t-shadow-sm hover:t-shadow-[0_4px_12px_rgba(26,107,90,0.28)] t-transition t-mb-2 disabled:t-opacity-50 disabled:t-cursor-not-allowed"
      >
        <span>{t('CancelFlow_Other_Confirm')}</span>
        <span aria-hidden="true">✓</span>
      </button>

      <button
        type="button"
        onClick={onClose}
        disabled={isSubmitting}
        className="t-block t-w-full t-text-center t-text-sm t-text-slate-600 hover:t-text-slate-800"
      >
        {t('CancelFlow_Other_NeverMind')}
      </button>
    </>
  );
}

export default OtherScreen;
